import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedModule } from '../shared.module';
import { ConfirmationPopupService } from './confirmation-popup.service';
import { ConfirmationPopupButton, IConfirmationPopupComponentData, IConfirmationPopupComponentFlags, IConfirmationPopupComponentResult } from './interfaces';

@Component({
  standalone: true,
  templateUrl: 'confirmation-popup.component.html',
  imports: [SharedModule]
})
export class ConfirmationPopupComponent implements OnInit {
  flags: IConfirmationPopupComponentFlags = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IConfirmationPopupComponentData,
    private dialogRef: MatDialogRef<ConfirmationPopupComponent, IConfirmationPopupComponentResult>,
    private confirmationPopupSvc: ConfirmationPopupService
  ) {
  }

  ngOnInit(): void {
    this.confirmationPopupSvc.setButtonFlags(this.flags, this.data.buttons);
  }

  onOkClick(): void {
    this.closeDialog(ConfirmationPopupButton.ok);
  }

  onCancelClick(): void {
    this.closeDialog(ConfirmationPopupButton.cancel);
  }

  onYesClick(): void {
    this.closeDialog(ConfirmationPopupButton.yes);
  }

  onNoClick(): void {
    this.closeDialog(ConfirmationPopupButton.no);
  }

  closeDialog(selectedButton: ConfirmationPopupButton): void {
    const result: IConfirmationPopupComponentResult = { selectedButton: selectedButton };
    this.dialogRef.close(result);
  }
}
